import { Trans } from '@/components'

import { IFile } from '../fs'

interface PathBreadcrumbProps {
  /**
   * List of path segments (e.g., ['folder1', 'folder2'])
   */
  pathList: string[]
  /**
   * Callback when user clicks on a path segment
   */
  onNavigate: (path: string) => void
  /**
   * Current files in directory
   */
  files: IFile[]
  /**
   * Files currently being uploaded
   */
  uploadingTasks: Array<{ name: string; size: number; loaded?: number; status: number }>
  /**
   * Currently selected files
   */
  selectedRows: IFile[]
}

/**
 * Breadcrumb navigation with file statistics
 * Shows path navigation and file counts (selected/uploading/total)
 */
export function PathBreadcrumb({
  pathList,
  onNavigate,
  files,
  uploadingTasks: _uploadingTasks,
  selectedRows,
}: PathBreadcrumbProps) {
  return (
    <div className="mt-4 mb-2 flex justify-between t-sb text-secondary">
      <div className="flex items-center gap-1">
        <button type="button" onClick={() => onNavigate('/')}>
          <Trans i18nKey="data.allFiles">All files</Trans>
        </button>
        {pathList.map((path, index) => (
          <div key={index} className="flex items-center gap-1">
            <div className="text-tertiary">/</div>
            <button
              type="button"
              onClick={() => onNavigate(pathList.slice(0, index + 1).join('/'))}
            >
              {path}
            </button>
          </div>
        ))}
      </div>
      <div>
        {selectedRows.length > 0 ? (
          <Trans i18nKey="data.selectedOfTotal">
            Selected {{ select: selectedRows.length }} / {{ total: files.length }}
          </Trans>
        ) : (
          <Trans i18nKey="data.totalFiles">Total {{ total: files.length }} files</Trans>
        )}
      </div>
    </div>
  )
}
